import React from "react";
import { Box, Typography } from "@material-ui/core";
const DeliveryDescription = () => (
  <Box>
    <Typography gutterBottom variant="body2">
      Delivery practices focus on delivering the options you have decided on and
      getting feedback from the users and stakeholders.
    </Typography>
    <Typography variant="body2">
      <i>What was the measured impact? What did you learn?</i>
    </Typography>
  </Box>
);
export default DeliveryDescription;
